const theme = {
    grayBg:"#f4f5f6",
    mainBg: "#fff",
    dashLine: "#e8e8e8",
    
    fontEmphaticalColor: "#252525",
    fontNomarlColor: "#5a5a62",
    fontGrayColor: "#8e8e93",

    primaryColor: "#ff4500",
    primaryHalf: "#ffa27f",
    green: "#05aa3b",
    halfGreen: "#82d49c",
    blue: "#459df5",
    yellow: "#fbc02d",
    pink: "#fbc02d"
}

export default theme


// WEBPACK FOOTER //
// ./src/theme.js


// WEBPACK FOOTER //
// ./src/theme.js